import definition from './toast.service';

/**
 * ToastService settings
 * @type {{name: string, definition: ToastService}}
 */
export default {
    name: 'ToastService',
    definition
};



// WEBPACK FOOTER //
// ./app/services/toast/index.js